export class AbandonnerDossier
{
    requestId: String;
    motif: String;
}